import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "d-flex",
  style: {"min-height":"45vw"}
}
const _hoisted_2 = { class: "content p-4 w-100" }
const _hoisted_3 = { class: "d-flex justify-content-between mb-1" }
const _hoisted_4 = { class: "card-title mt-0" }
const _hoisted_5 = { class: "mb-5 d-flex justify-end" }
const _hoisted_6 = { class: "btn-area" }

import CreateOrUpdateModal from "@/components/Department/CreateOrUpdateModal.vue"
import getDepartmentAllParams from "@/types/responses/getDepartmentAllParams"
import getOperationOfficeResponse from "@/types/responses/getOperationOffice"
import getPagenateDepartment from  "@/types/responses/getPagenateDepartment"
import DepartmentsList from "@/components/Department/DepartmentsList.vue"
import getDepartmentResponse from "@/types/responses/getDepartment"
import DeleteModal from "@/components/Department/DeleteModal.vue"
import SearchForm from "@/components/Department/SearchForm.vue"
import { useAuth } from "@/services/user/Auth0UserProvider"
import getDepartment from "@/types/requests/getDepartment"
import PaginateWithCount from "@/components/PaginateWithCount.vue"
import { Ref, ref, reactive, onMounted, watch } from "vue"
import { MANAGEMENT_OFFICE_TYPE, DEPARTMENT_OFFICE_TYPE } from "@/services/consts"
import SelectRoleChecker from "@/router/selectRoleChecker"
import { getAuthorities } from "@/services/functions"
import Api from "@/services/api/ApiServiceFabrick"
import getRole from '@/types/responses/getRole'
import SelfAccount from "@/types/SelfAccount"
import i18n from "@/lang/i18n"

type formType = {
  operationOffice: getOperationOfficeResponse | null,
  parent: getDepartmentResponse | null
}


export default /*@__PURE__*/_defineComponent({
  __name: 'DepartmentList',
  props: {
    showFlash: { type: Function }
  },
  setup(__props: any) {

const props = __props

document.title = i18n.global.t('pages.departments.title')
const errors: Ref<any> = ref({})
const totalPage: Ref<number> = ref(0)
const itemsPerPage: Ref<number> = ref(15)
const allElementsCount: Ref<number> = ref(0)
const currentPage: Ref<number> = ref(1)
const { loginWithRedirect } = useAuth()
const departments: Ref<getDepartmentAllParams[]> = ref([])
const selectedDepartment: Ref<getDepartmentAllParams | null> = ref(null)
const isLoading: Ref<boolean> = ref(false)
const isSearchCompleted: Ref<boolean> = ref(false)
const createAuthority: Ref<boolean> = ref(false)
const updateAuthority: Ref<boolean> = ref(false)
const deleteAuthority: Ref<boolean> = ref(false)
const deleteModalStatus: Ref<boolean> = ref(false)
const createOrUpdateModalStatus: Ref<boolean> = ref(false)
const isManagementOffice: Ref<boolean> = ref(false)
const isDepartment: Ref<boolean> = ref(false)
const isChildDepartment: Ref<boolean> = ref(false)
const selfAccount = ref({} as SelfAccount)
const selfRole = ref({} as getRole)
const parentIdExistsDepartments: Ref<getDepartmentAllParams[]> = ref([])
const loginOrganizationId: Ref<number | undefined> = ref(undefined)
const searchParams: getDepartment = reactive({
  page: 1,
  operation_office_id: null,
  parent_id: null,
})

onMounted(async () => {
  getAuthorityList()
  getAllDepartments()
  await getSelf()
  if (!isManagementOffice.value) {
    getDepartments()
  }
})

async function getAuthorityList(isError = false) {
  const authorities = await getAuthorities(isError)
  createAuthority.value = authorities["octlink.department.create"]
  updateAuthority.value = authorities["octlink.department.update"]
  deleteAuthority.value = authorities["octlink.department.delete"]
}

function getDepartments() {
  isLoading.value = true
  Api().getDepartments(searchParams).then((data: getPagenateDepartment) => {
    departments.value = data.data
    currentPage.value = data.current_page
    totalPage.value = data.total_page
    allElementsCount.value = data.total
    itemsPerPage.value = data.per_page
    isLoading.value = false
    isSearchCompleted.value = true
  })
}

async function getSelf() {
  await Api().getSelfAccount().then((data) => {
    selfAccount.value = data
    isDepartment.value = data.login_organization_type == DEPARTMENT_OFFICE_TYPE
    isManagementOffice.value = data.login_organization_type == MANAGEMENT_OFFICE_TYPE
    loginOrganizationId.value = data.login_organization_id
    selfRole.value = SelectRoleChecker.getCurrentRole()
    if (isDepartment.value) isChildDepartment.value = !!selfRole.value?.organization.parent_id
  }).catch((error) => {
    return errorHandle(error.response)
  })
}

function getAllDepartments() {
  const params = {
    operation_office_id: null,
    parent_id: null,
  }
  Api().getDepartments(params).then((data: getPagenateDepartment) => {
    data.data.forEach((department: getDepartmentAllParams) => {
      if (department.parent_id) parentIdExistsDepartments.value.push(department)
    })
  })
}

function openModal(department: getDepartmentAllParams | null = null) {
  createOrUpdateModalStatus.value = true
  if (department) selectedDepartment.value = department
}

function openDeleteModal(department: getDepartmentAllParams) {
  deleteModalStatus.value = true
  selectedDepartment.value = department
}

function errorHandle (res: any) {
  switch (res.status) {
    case 401:
      loginWithRedirect({ appState: { targetUrl: location.pathname } })
      isLoading.value = false
      break
    case 403:
      props.showFlash(i18n.global.t('pages.common.messages.forbidden'), "error", true)
      isLoading.value = false
      break
    case 422:
      errors.value = res.data.errors
  }
  return isLoading.value = false
}

function searchDepartmentList(values: formType) {
  searchParams.page = 1
  searchParams.operation_office_id = values.operationOffice ? values.operationOffice.id : null
  searchParams.parent_id = values.parent ? values.parent.id : null
  getDepartments()
}

function closeModal(isReacquire: boolean) {
  selectedDepartment.value = null
  createOrUpdateModalStatus.value = false
  deleteModalStatus.value = false
  if (isReacquire) {
    searchParams.page = 1
    getDepartments()
  }
}

watch(currentPage, () => {
  searchParams.page = currentPage.value
  getDepartments()
})

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h4", _hoisted_4, _toDisplayString(_unref(i18n).global.t('pages.departments.title')), 1)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            (createAuthority.value && !isChildDepartment.value)
              ? (_openBlock(), _createBlock(_component_v_btn, {
                  key: 0,
                  class: "exec-btn mt-0",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (openModal()))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(i18n).global.t('pages.common.button.newCreate')), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", null, [
          _createVNode(DepartmentsList, {
            class: "mb-2",
            departments: departments.value,
            isLoading: isLoading.value,
            deleteAuthority: deleteAuthority.value,
            selfAccount: selfAccount.value,
            isDepartment: isDepartment.value,
            isManagementOffice: isManagementOffice.value,
            isSearchCompleted: isSearchCompleted.value,
            openModal: openModal,
            deleteModal: openDeleteModal
          }, null, 8, ["departments", "isLoading", "deleteAuthority", "selfAccount", "isDepartment", "isManagementOffice", "isSearchCompleted"]),
          _createVNode(PaginateWithCount, {
            class: "justify-end",
            totalPage: totalPage.value,
            modelValue: currentPage.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((currentPage).value = $event)),
            itemsPerPage: itemsPerPage.value,
            allElementsCount: allElementsCount.value,
            showItemCount: true
          }, null, 8, ["totalPage", "modelValue", "itemsPerPage", "allElementsCount"])
        ])
      ]),
      _createVNode(SearchForm, {
        isLoading: isLoading.value,
        isChildDepartment: isChildDepartment.value,
        onSearch: searchDepartmentList
      }, null, 8, ["isLoading", "isChildDepartment"])
    ]),
    (createOrUpdateModalStatus.value)
      ? (_openBlock(), _createBlock(CreateOrUpdateModal, {
          key: 0,
          modelValue: createOrUpdateModalStatus.value,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((createOrUpdateModalStatus).value = $event)),
          parentIdExistsDepartments: parentIdExistsDepartments.value,
          department: selectedDepartment.value,
          isDepartment: isDepartment.value,
          isChildDepartment: isChildDepartment.value,
          loginOrganizationId: loginOrganizationId.value,
          updateAuthority: updateAuthority.value,
          closeModal: closeModal,
          showFlash: props.showFlash
        }, null, 8, ["modelValue", "parentIdExistsDepartments", "department", "isDepartment", "isChildDepartment", "loginOrganizationId", "updateAuthority", "showFlash"]))
      : _createCommentVNode("", true),
    (deleteModalStatus.value)
      ? (_openBlock(), _createBlock(DeleteModal, {
          key: 1,
          modelValue: deleteModalStatus.value,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((deleteModalStatus).value = $event)),
          parentIdExistsDepartments: parentIdExistsDepartments.value,
          department: selectedDepartment.value,
          closeModal: closeModal,
          showFlash: props.showFlash
        }, null, 8, ["modelValue", "parentIdExistsDepartments", "department", "showFlash"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})